export default __webpack_public_path__ + "resources/icons/n422-c7c0.png";